module.exports = __webpack_public_path__ + "static/media/pnd.1e92249c.png";